/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
	@Serenity.Decorators.panel()
    export class SecurityOverrideDialog extends SiteEntityDialog<SecurityOverrideRow, any> {
        protected getFormKey() { return SecurityOverrideForm.formKey; }
        protected getIdProperty() { return SecurityOverrideRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityOverrideRow.localTextPrefix; }
        protected getNameProperty() { return SecurityOverrideRow.nameProperty; }
        protected getService() { return SecurityOverrideService.baseUrl; }

        protected form = new SecurityOverrideForm(this.idPrefix);

        constructor(options?: any) {
            super(options);

            this.form.GicsSelection.change(e => {
                SecurityDialog.gicsSetFormValues(this.form, false, null);
                setOverrideChecked(this.form.GicsSector.getGridField().find('.override-value'), !isNullValue(this.form.GicsSelection.get_value()));
            });

            var secRequired: Q.Dictionary<boolean> = {};
            for (var x of Q.getForm(SecurityForm.formKey))
                secRequired[x.name] = x.required;

            this.propertyGrid.enumerateItems((item, editor) => {
                if (!item.name ||
                    item.required ||
                    (Q.startsWith(item.name, "Gics") && item.name != "GicsSector") ||
                    (item.insertable == false &&
                        item.updatable == false))
                    return;

                $(`<a class="override-value ${!secRequired[item.name] ? " allow-null": ""}" title="Override">
<i class="ni ni-square"></i></a>`)
                    .insertAfter(editor.getGridField().children('label.caption'));
            });

            this.element.on('click', 'a.override-value', (e) => {
                if (this.isViewMode())
                    return;

                var link = $(e.currentTarget);

                var editorEl = link.closest('.field').find('.editor').not('.select2-container').first();
                if (!editorEl.length)
                    return;

                var editor = editorEl.tryGetWidget(Serenity.Widget);
                if (!editor)
                    return;

                var checked = !link.hasClass('is-checked');

                if (!link.hasClass('allow-null') && checked)
                    return;

                var checked = !link.hasClass('is-checked');
                setOverrideChecked(link, checked);

                if (!checked) {
                    Serenity.EditorUtils.setValue(editor, null);
                    if (editor == this.form.GicsSector) {
                        this.form.GicsSelection.set_value(null);
                        this.form.GicsIndustry.value = null;
                        this.form.GicsIndustryGroup.value = null;
                        this.form.GicsSubIndustry.value = null;
                    }
                }

            });

            this.element.on('input change', '.editor', (e) => {
                if (this.isViewMode())
                    return;

                var editorEl = $(e.currentTarget);
                if (!editorEl.length)
                    return;

                var link = editorEl.closest('.field').children('.override-value');
                if (!link.length)
                    return;

                var editor = editorEl.tryGetWidget(Serenity.Widget);
                if (!editor)
                    return;

                var checked = !isNullValue(Serenity.EditorUtils.getValue(editor));

                setOverrideChecked(link, checked);
            });
        }

        protected updateInterface() {
            Serenity.EditorUtils.setReadOnly(this.form.SecurityId, !!this.entity.SecurityId);
            super.updateInterface();
        }

        getLoadByIdRequest(id: any) {
            var request = super.getLoadByIdRequest(id);
            request.IncludeColumns = request.IncludeColumns || [];
            request.IncludeColumns.push(SecurityOverrideRow.Fields.OverrideNull);
            return request;
        }

        loadEntity(entity) {
            super.loadEntity(entity);
            SecurityDialog.gicsLoadEntity(entity, this.form);

            this.propertyGrid.enumerateItems((item, editor) => {
                var overrideValue = editor.getGridField().children('.override-value').first();
                if (!overrideValue.length)
                    return;

                var checked = this.entity[item.name] != null ||
                    (this.entity.OverrideNull &&
                        !!this.entity.OverrideNull[item.name]);
                setOverrideChecked(overrideValue, checked);
            });
        }

        getSaveEntity() {
            var entity = super.getSaveEntity();
            entity.SecurityId = Q.coalesce(entity.SecurityId, this.entity.SecurityId);
            SecurityDialog.gicsSaveEntity(entity);
            entity.OverrideNull = {};
            this.propertyGrid.enumerateItems((item, editor) => {
                var overrideValue = editor.getGridField().children('.override-value').first();
                if (!overrideValue.length)
                    return;

                if (overrideValue.hasClass("is-checked") &&
                    isNullValue(Serenity.EditorUtils.getValue(editor)) &&
                    overrideValue.hasClass("allow-null"))
                    entity.OverrideNull[item.name] = true;
            });

            if (entity.GicsSector != null ||
                entity.OverrideNull.GicsSector) {
                if (entity.OverrideNull.GicsSector ||
                    entity.GicsIndustry == null)
                    entity.OverrideNull.GicsIndustry = true;

                if (entity.OverrideNull.GicsSector ||
                    entity.GicsIndustryGroup == null)
                    entity.OverrideNull.GicsIndustryGroup = true;

                if (entity.OverrideNull.GicsSubIndustry ||
                    entity.GicsSubIndustry == null)
                    entity.OverrideNull.GicsSubIndustry = true;
            }

            return entity;
        }
    }

    function isNullValue(value) {
        return value == null ||
            (typeof value == "string" && Q.isTrimmedEmpty(value));
    }

    function setOverrideChecked(link: JQuery, checked: boolean) {
        link.toggleClass('is-checked', !!checked)
            .children('i')
            .toggleClass('ni-square', !checked)
            .toggleClass('ni-check-round-cut', !!checked);
    }
}